import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/winston.webp';
import screenshot_target from '../../../images/letterfunnel/koenlavrijssen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Koen Lavrijssen"
      firstname="Koen"
      companyname="Winston"
      competition="Bizzon en Toast"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/koenlavrijssen.js